// extracted by mini-css-extract-plugin
module.exports = {"icecream":"IceCream_icecream__x_RIV","cone":"IceCream_cone__3Jknj","cherry":"IceCream_cherry__3Ld1Y"};